// Power Level tiers based on ELO rating
export const POWER_TIERS = [
  { name: 'bronze',      min: 0,    max: 1099, color: '#CD7F32', bg: 'from-amber-800 to-amber-600',   glow: 'shadow-amber-500/30' },
  { name: 'silver',      min: 1100, max: 1299, color: '#C0C0C0', bg: 'from-slate-400 to-slate-300',   glow: 'shadow-slate-400/30' },
  { name: 'gold',        min: 1300, max: 1499, color: '#FFD700', bg: 'from-yellow-500 to-amber-400',  glow: 'shadow-yellow-500/40' },
  { name: 'platinum',    min: 1500, max: 1699, color: '#00D4FF', bg: 'from-cyan-500 to-blue-400',     glow: 'shadow-cyan-400/40' },
  { name: 'diamond',     min: 1700, max: 1899, color: '#B9F2FF', bg: 'from-sky-300 to-blue-300',      glow: 'shadow-sky-300/50' },
  { name: 'grandmaster', min: 1900, max: 9999, color: '#39FF14', bg: 'from-green-400 to-emerald-300', glow: 'shadow-green-400/50' },
];

export function getPowerTier(elo) {
  return POWER_TIERS.find(t => elo >= t.min && elo <= t.max) || POWER_TIERS[0];
}

export function getTierProgress(elo) {
  const tier = getPowerTier(elo);
  const range = tier.max - tier.min;
  const progress = ((elo - tier.min) / range) * 100;
  return Math.min(Math.max(progress, 0), 100);
}

export function getNextTier(elo) {
  const currentIdx = POWER_TIERS.findIndex(t => elo >= t.min && elo <= t.max);
  return currentIdx < POWER_TIERS.length - 1 ? POWER_TIERS[currentIdx + 1] : null;
}

// Unlockable Titles based on player stats
export function getPlayerTitles(stats) {
  if (!stats) return [];
  const titles = [];
  const mp = stats.matches_played || 0;
  const mw = stats.matches_won || 0;
  const winRate = mp > 0 ? (mw / mp) * 100 : 0;

  if (mp >= 50)                              titles.push({ key: 'courtRegular', icon: 'repeat', desc: '50+ matches played' });
  if (stats.best_streak >= 5)                titles.push({ key: 'streakMaster', icon: 'flame', desc: `${stats.best_streak} win streak` });
  if (stats.total_points_scored >= 500)      titles.push({ key: 'smashKing', icon: 'zap', desc: `${stats.total_points_scored} points scored` });
  if (winRate >= 60 && mp >= 10)             titles.push({ key: 'sharpShooter', icon: 'target', desc: `${Math.round(winRate)}% win rate` });
  if (stats.total_points_conceded > 0 && stats.total_points_scored > 0) {
    const ratio = stats.total_points_scored / stats.total_points_conceded;
    if (ratio >= 1.3 && mp >= 10)            titles.push({ key: 'theWall', icon: 'shield', desc: 'Elite point ratio' });
  }
  if (stats.elo_rating >= 1600)              titles.push({ key: 'ironDefense', icon: 'lock', desc: `ELO ${stats.elo_rating}` });
  if (mp > 0 && mp < 10)                     titles.push({ key: 'rookie', icon: 'star', desc: 'Just getting started' });

  return titles;
}

// Streak badge calculation
export function getStreakInfo(currentStreak) {
  if (currentStreak >= 10) return { level: 'inferno',   label: 'INFERNO',   color: 'text-red-500',    flames: 3 };
  if (currentStreak >= 5)  return { level: 'hot',       label: 'HOT STREAK',color: 'text-orange-500', flames: 2 };
  if (currentStreak >= 3)  return { level: 'warm',      label: 'ON FIRE',   color: 'text-yellow-500', flames: 1 };
  return null;
}
